export function localizeSmsError(message: string): string {
  if (message.trim().replace(/\.+$/, '') === 'Invalid or expired SMS code') {
    return 'Неверный код или срок его действия истёк.';
  }
  return message;
}
